//登录

import { deleteRequest, downPostRequest, getRequest, postRequest, putRequest } from '@/config/request';
import { SYS_BASE_URL } from "@/constant/Const";

export const login = (data) =>{
    return postRequest(SYS_BASE_URL + "/api/login/login",data);
}

export const logout = (data) =>{
    return getRequest(SYS_BASE_URL + "/api/login/logout",data);
}

//获取路由
export const getRouteList = (data) =>{
    return getRequest(SYS_BASE_URL + "/api/user/tree",data);
}